import React from 'react';

const IconHelpChat = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 3.75c4.55 0 8.25 3.2 8.25 7.15 0 3.95-3.7 7.15-8.25 7.15-.9 0-1.77-.12-2.58-.36l-4.02 2.06.96-3.4c-1.63-1.3-2.61-3.16-2.61-5.45 0-3.95 3.7-7.15 8.25-7.15Z'
      stroke='#FF2D38'
      strokeWidth='1.7'
      strokeLinejoin='round'
    />
    <circle cx='8.6' cy='10.9' r='1.15' fill='#FF2D38' />
    <circle cx='12' cy='10.9' r='1.15' fill='#FF2D38' />
    <circle cx='15.4' cy='10.9' r='1.15' fill='#FF2D38' />
  </svg>
);

export default IconHelpChat;
